import React, { useEffect, useMemo, useCallback } from "react";
import {
	Avatar,
	Chip,
	Pagination,
	Tooltip,
} from "@heroui/react";
import { CheckIcon } from "../pages/ChatPage";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { parseMessage } from "./ChatArea";

function parseGuardNum(e) {
	var obj = JSON.parse(e.Extra);
	return obj.data.num;
}

function ActionTable2(props) {
	const [currentPage, setCurrentPage] = React.useState(
		props.page !== undefined
			? props.page
			: window.USER_PAGE
				? window.USER_PAGE
				: props.initialPage
					? props.initialPage
					: 1,
	);

	const redirect = useNavigate();

	const pageSize = parseInt(localStorage.getItem("defaultPageSize")) || 20;

	const [showName, setShowName] = React.useState(() => {
		return parseInt(localStorage.getItem("showName")) || 0;
	});

	// 同步外部 page 属性
	useEffect(() => {
		if (props.page !== undefined && props.page !== currentPage) {
			setCurrentPage(props.page);
		}
	}, [props.page]);

	useEffect(() => {
		setTimeout(() => {
			if (props.highLight) {
				const element = document.getElementById(props.highLight);
				if (element) {
					element.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
				}
			}
		}, 1000);
	}, []);

	useEffect(() => {
		return () => {
			window.USER_PAGE = 1;
		};
	}, []);

	const hasLiver = useMemo(() => {
		return (
			props.dataSource?.length > 0 &&
			props.dataSource[0].liver_id !== undefined
		);
	}, [props.dataSource]);

	const renderCell = useCallback(
		(item, columnKey, highLight) => {
			switch (columnKey) {
				case "UserName":
					return (
						<div
							className="hover:text-gray-500 flex items-center whitespace-nowrap min-w-[50px] cursor-pointer"
							onClick={() => {
								redirect("/user/" + item.from_id);
							}}
						>
							{!props.disableAvatar && item.from_id !== 0 && (
								<Avatar
									src={`${AVATAR_API}${item.from_id}`}
									className={"mr-2 shrink-0"}
								/>
							)}
							<span className="shrink-0">{item.from_name}</span>
							{item.medal_level !== 0 && item.medal_level && (
								<Chip
									className="basis-64 shrink-0"
									startContent={
										item.guard_level ? (
											<img
												src={getGuardIcon(
													item.guard_level,
												)}
												alt="guard"
												width={20}
												height={20}
											/>
										) : (
											<CheckIcon size={18} />
										)
									}
									variant="faded"
									onClick={(e) => {
										e.stopPropagation();
										toSpace(item.medal_liver);
									}}
									style={{
										background: getColor(item.medal_level),
										color: "white",
										marginLeft: "8px",
									}}
								>
									{item.medal_name}
									<span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
										{item.medal_level}
									</span>
								</Chip>
							)}
						</div>
					);

				case "Liver":
					return (
						<NavLink
							className="flex hover:text-gray-500 whitespace-nowrap"
							to={"/liver/" + item.liver_id}
						>
							{!isMobile() && (
								<Avatar
									className="w-[40px] h-[40px]"
									src={`${AVATAR_API}${item.liver_id}`}
								/>
							)}
							<span className="ml-2 mt-2">{item.liver_name}</span>
						</NavLink>
					);

				case "StartAt":
					return (
						<span className="whitespace-nowrap">
							{timestampToDate(item.created_at).toLocaleString()}
						</span>
					);

				case "Message":
					if (item.action_type === 3) {
						var m = new Map();
						m.set("舰长", 138);
						m.set("提督", 1598);
						m.set("总督", 15998);

						if (item.gift_amount == null) {
							if (item.extra && item.extra.includes("GUARD_BUY")) {
								try {
									var obj = JSON.parse(item.extra);
									item.gift_amount = obj.data.num;
									item.gift_price =
										(item.gift_amount * obj.data.price) / 1000;
								} catch (e) {}
							}
							if (item.extra === null || item.extra === "") {
								item.gift_amount =
									item.gift_price / m.get(item.gift_name);
							}
						}
					}
					if (item.action_type === 9 || item.action_type === 10) {
						item.gift_name = "发红包";
					}
					item.gift_price = formatFloat(item.gift_price);
					return (
						<div
							className={`transition-transform hover:text-gray-500 whitespace-nowrap ${
								item.action_type !== 1 ? "font-bold" : ""
							}`}
						>
							<a
								title={props.disableLocate?'':'点击跳转'}
								className={`cursor-pointer ${highLight ? "bg-blue-300" : ""}`}
								onClick={() => {
									if (props.disableLocate) return;
									axios
										.get(
											`/api/actions/locate?id=${item.id}&live=${item.live}&size=${pageSize}`,
										)
										.then((response) => {
											window.open(
												`/lives/${item.live}?page=${response.data.page}&highLight=${item.id}`,
											);
										});
								}}
								dangerouslySetInnerHTML={{
									__html:
										item.action_type === 9
											? "[红包] " +
											JSON.parse(item.extra)
												.awards?.[0]
												?.gift_name +
											" *" +
											JSON.parse(item.extra)
												.awards?.[0]?.num
											: item.action_type === 10
												? `天选开奖 (共 ${JSON.parse(item.extra).total_num || 0} 人)`
												: item.gift_name ||
												parseMessage(
													item.extra,
													item.emotes ??
													new Map(),
												),
								}}
							/>

							{(item.action_type === 2 ||
								item.action_type === 3) && (
								<span>
									*{item.gift_amount}{" "}
									{item.gift_price
										? ` ￥ ${item.gift_price}`
										: ""}
								</span>
							)}
							{item.action_type === 4 && (
								<span>
									{item.gift_price
										? ` ￥ ${item.gift_price}`
										: ""}
								</span>
							)}
						</div>
					);

				default:
					return null;
			}
		},
		[pageSize, redirect, props.disableAvatar, props.disableLocate],
	);

	return (
		<div
			className="w-full overflow-x-scroll scrollbar-hide"
			ref={props.ref}
		>
			<table className="min-w-full w-full border-separate border-spacing-y-1">
				<tbody>
					{props.dataSource && props.dataSource.length > 0 ? (
						props.dataSource.map((item, index) => {
							const isHighlighted =
								String(item.id) === String(props.highLight);
							const isOdd = index % 2 === 1;
							const bgClass = isHighlighted
								? "bg-blue-200 dark:bg-blue-900/50"
								: isOdd
									? "bg-default-100"
									: "bg-transparent";
							return (
								<tr
									key={item.ID || item.id || Math.random()}
									id={item.id}
									/* 使用 CSS 原生 content-visibility 实现类似虚拟滚动 */
									style={{
										contentVisibility: "auto",
										containIntrinsicSize: "auto 56px",
									}}
									className="group h-[56px] transition-colors"
								>
									{/* 用户列: 随内容自适应撑开，不换行 */}
									<td
										className={`py-2 px-3 align-middle text-small font-normal text-foreground whitespace-nowrap rounded-l-lg ${bgClass}  transition-colors`}
									>
										{renderCell(
											item,
											"UserName",
											isHighlighted,
										)}
									</td>

									{/* 主播列 (如果存在) */}
									{hasLiver && (
										<td
											className={`py-2 px-3 align-middle text-small font-normal text-foreground whitespace-nowrap ${bgClass}  transition-colors`}
										>
											{renderCell(
												item,
												"Liver",
												isHighlighted,
											)}
										</td>
									)}

									{/* 时间列: 随内容自适应撑开，不换行 */}
									<td
										className={`py-2 px-3 align-middle text-small font-normal text-foreground whitespace-nowrap ${bgClass} transition-colors`}
									>
										{renderCell(
											item,
											"StartAt",
											isHighlighted,
										)}
									</td>

									{/* 消息列: 占据剩余全部宽度 */}
									<td
										className={`py-2 px-3 align-middle text-small font-normal text-foreground w-full rounded-r-lg ${bgClass}  transition-colors`}
									>
										{renderCell(
											item,
											"Message",
											isHighlighted,
										)}
									</td>
								</tr>
							);
						})
					) : (
						<tr>
							<td
								colSpan={hasLiver ? 4 : 3}
								className="text-foreground-400 text-center h-40 text-small align-middle"
							>
								暂无数据
							</td>
						</tr>
					)}
				</tbody>
			</table>

			{/* 底部分页与原 ActionTable 100% 保持一致 */}
			<div className="flex w-full justify-center my-4">
				<Pagination
					isCompact
					showControls
					showShadow
					color="secondary"
					page={currentPage}
					total={
						Math.ceil((props.total || 0) / pageSize) || 1
					}
					onChange={(page) => {
						setCurrentPage(page);
						props.handlePageChange(page, pageSize);
					}}
				/>
			</div>
		</div>
	);
}

export default ActionTable2;
